import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import Table from "../../core/common/dataTable/index";
import CollapseHeader from '../../core/common/collapse-header/collapse-header'
import DeleteModal from '../../core/modals/deleteModal'
import CopyRightInfo from '../../core/common/copyRightInfo'
import ModifyPermission from './modifyPermissions'
import useFetch from '../../hooks/useFetch';
import { Role } from '../../types/dataModel';
import PreLoader from '../../core/common/preLoader';
import { getAPIHeaders , getFormattedDateDDMMYYYY } from '../../common/Utils';
import { API } from '../../common/Constants';
import ModifyRole from './modifyRole';
import { useAccess } from '../../hooks/accessContext';
import '../../style/css/rolePermissions.css';
// Import shared styles for tooltips and action icons
import "../../style/css/shared.scss";
import CustomToast from '../../core/common/customToast';

const RolesPermission = () => {
    const {hasUserMgntCreate, hasUserMgntEdit } = useAccess()
    const columns = [
        {
            title: "ID",
            dataIndex: "id",
            render: (text: String, record: any) => (
              <h6 className="fw-medium">
                <Link to="#">{text}</Link>
              </h6>
      
            ),
            sorter: (a: any, b: any) => a.id - b.id,
          },
        {
            title: "Role",
            dataIndex: "name",
            defaultSortOrder: 'ascend',
            render: (text: String, record: any) => (
                <div className="d-flex align-items-center">
                <div className="ms-2 role-title">
                    <h6 className="fw-medium mb-1">
                        <Link to="#"
                        data-bs-toggle="modal" data-inert={true}
                        data-bs-target="#modify_role"
                        onClick={() => { setEditRole(record) }}
                        >
                        {record.name}
                        </Link>
                    </h6>
                    <span className="fs-12 text-muted">{record.description}</span>
                </div>
                </div>
            ),
            
            sorter: (a: any, b: any) => a?.name?.localeCompare(b.name),
        },
        {
            title: "Last Modified",
            dataIndex: "createdOn",
            sorter: (a: any, b: any) => a.createdOn - b.createdOn,
            render: (text: string, record: any) => (
                <div className="timestamp-container">
                    <div className='d-flex flex-column mb-1'>
                        <div className="timestamp-row">
                            <span className='text-dark fw-medium fs-12'>Created:</span>
                            <span className='text-muted fs-12 ms-1'>{getFormattedDateDDMMYYYY(record?.createdOn)}</span>
                            <span className='text-muted fs-12 ms-2'>by {record?.createdBy}</span>
                        </div>
                    </div>
                    <div className='d-flex flex-column'>
                        <div className="timestamp-row">
                            <span className='text-dark fw-medium fs-12'>Updated:</span>
                            <span className='text-muted fs-12 ms-1'>{getFormattedDateDDMMYYYY(record?.updatedOn)}</span>
                            <span className='text-muted fs-12 ms-2'>by {record?.updatedBy}</span>
                        </div>
                    </div>
                </div>
            )
        },
        {
            title: "Status",
            dataIndex: "status",
            render: (text: string, record: any) => (
                <div className="d-flex align-items-center">
                    <span
                        className={`badge d-inline-flex align-items-center badge-xs ${text === 'ACTIVE'
                            ? 'badge-success'
                            : 'badge-danger'
                            }`}
                    >
                        <i className="ti ti-point-filled me-1"></i>
                        {text}
                    </span>

                    {
                        record?.isDefault && 
                        <span className="ms-2 badge d-inline-flex align-items-center badge-xs badge-secondary">
                            <i className="ti ti-star-filled me-1"></i>
                            DEFAULT
                        </span>
                    }
                </div>
            ),
            sorter: (a: any, b: any) => a.status.length - b.status.length,
        },
        {
            title: "",
            dataIndex: "actions",
            render: (text:string, record:any) => (
                !record?.isDefault 
                ?
                <div className="action-icon d-inline-flex">
                    <Link to={"#"} className="me-2 icon-edit"
                        data-bs-toggle="modal" data-inert={true}
                        data-bs-target="#modify_roles_permissions"
                        title="Manage Permissions"
                        onClick={()=>{
                            setEditRole(record)
                        }}>
                        <i className="ti ti-shield" />
                    </Link>
                    <Link
                        to="#"
                        className="icon-edit"
                        data-bs-toggle="modal" data-inert={true}
                        data-bs-target="#modify_role"
                        title="Edit Role"
                        onClick={()=>{
                            setEditRole(record)
                        }}
                    >
                        <i className="ti ti-edit" />
                    </Link>
                    <Link
                        to="#"
                        className="icon-delete"
                        data-bs-toggle="modal" data-inert={true}
                        data-bs-target="#delete_modal"
                        title="Delete Role"
                        onClick={()=>{
                            setEditRole(record)
                        }}
                    >
                        <i className="ti ti-trash" />
                    </Link>
                </div>
                :
                <div className="action-icon d-inline-flex">
                    <Link to="" className='icon-edit'
                            data-bs-toggle="modal" data-inert={true}
                            data-bs-target="#modify_roles_permissions"
                            title="View Permissions"
                            onClick={() => {
                                setEditRole(record)
                    }}>
                        <i className="ti ti-shield" />
                    </Link>
                </div>
            ),
        },
    ]

    const { isLoading, data, callFetch } = useFetch();
    const [roles, setRoles] = useState<Role[]>([]);
    const [editRole, setEditRole] = useState<Role>();
    const [toastSettings, setToastSettings] = useState<{
        show: boolean;
        message: string;
        heading: string;
        type: "ERROR" | "SUCCESS" | "INFO";
    }>({
        show: false,
        message: "Something went wrong please try again later",
        heading: "Oops! Something went wrong",
        type: "ERROR",
    });

    useEffect(() => {
        fetch()
    }, []);

    useEffect(() => {
        if (data) {
            setRoles(data)
        }
    }, [data]);

    const fetch = () => {
        callFetch(`${API.ROLES}?includePermissions=false`,
            'GET',
            getAPIHeaders(),
            null,
            null
        ).catch((err) => {});;
    }

    const handleDelete = () => {
        if (editRole) {
            callFetch(`${API.ROLE}/${editRole.id}`,
                'DELETE',
                getAPIHeaders(),
                null,
                null
            ).then(() => {
                setToastSettings({
                    show: true,
                    message: "Role deleted successfully",
                    heading: "Success",
                    type: "SUCCESS",
                });
                fetch();
            }).catch((error) => {
                setToastSettings({
                    show: true,
                    message: error?.response?.data || "Failed to delete role: " + editRole.name,
                    heading: "Error",
                    type: "ERROR",
                });
            });
        }
    }

    return (
        <>
            <PreLoader showLoader={isLoading} />
            <DeleteModal onDelete={handleDelete} />
            <CustomToast
                show={toastSettings?.show}
                message={toastSettings?.message}
                heading={toastSettings?.heading}
                type={toastSettings?.type}
                onClose={() => {
                setToastSettings((prev) => ({
                    ...prev,
                    show: false,
                }));
                }}
            />
            {/* Page Wrapper */}
            <div className="page-wrapper">
                <div className="content">
                    {/* Breadcrumb */}
                    <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
                        <div className="my-auto mb-2">
                            <h2 className="mb-1">Roles</h2>
                            <nav>
                                <ol className="breadcrumb mb-0">
                                    <li className="breadcrumb-item">
                                        <Link to={""}>
                                            <i className="ti ti-smart-home" />
                                        </Link>
                                    </li>
                                    <li className="breadcrumb-item">Administration</li>
                                    <li className="breadcrumb-item active" aria-current="page">
                                        Roles
                                    </li>
                                </ol>
                            </nav>
                        </div>
                        <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
                            <div className="mb-2">
                                <button
                                    disabled={!hasUserMgntCreate()}
                                    data-bs-toggle="modal" data-inert={true}
                                    data-bs-target="#modify_role"
                                    className="btn btn-primary d-flex align-items-center"
                                    onClick={()=>{
                                        setEditRole(undefined)
                                    }}
                                    
                                >
                                    <i className="ti ti-circle-plus me-2" />
                                    Add New Roles
                                </button>
                            </div>
                            <div className="head-icons ms-2">
                            <CollapseHeader />
                            </div>
                        </div>
                    </div>
                    {/* /Breadcrumb */}
                    {/* Assets Lists */}
                    <div className="card">
                        <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                            <h5>Roles List</h5>
                        </div>
                        <div className="card-body p-0">
                            <Table dataSource={roles} columns={columns} Selection={false} />
                        </div>
                    </div>
                </div>
                <div className="footer d-sm-flex align-items-center justify-content-center border-top bg-white p-3">
                    <CopyRightInfo/>
                </div>
            </div>
            {/* /Page Wrapper */}
            {/* Modify Role */}
            <ModifyRole 
                readonly={!hasUserMgntEdit()}
                role={editRole} 
                onCancel={()=>{
                    setEditRole(undefined)
                }} 
                onSuccess={fetch}
            />
            {/* /Modify Role */}
            {/* /Modify Permission */}
            <ModifyPermission roleID={editRole?.id} readOnly={editRole?.isDefault || !hasUserMgntEdit()}/>
            {/* /Modify Permission */}
        </>

    )
}

export default RolesPermission